import { observer } from 'mobx-react';
import { useStore } from '../../../../store/store';
import { FUND_FIELDS } from '../../../../utils/constants/fields';
import { formatNumber } from '../../../../utils/utils';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import ChipsList from '../../../../components/common/ChipsList';

const FundGeneralInformation = observer(({ entry }) => {
  const { utilsStore } = useStore();

  return (
    <div className="content">
      {!!entry.companyName && (
        <div className="row">
          <div className="bullet"></div>
          <div className="label">Private equity firm</div>
          <div className="value">{entry.companyName}</div>
        </div>
      )}
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.NAME.LABEL}</div>
        <div className="value">{entry[FUND_FIELDS.NAME.NAME] || PUNCTUATION.EMPTY_VALUE}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.VINTAGE.LABEL}</div>
        <div className="value">{entry[FUND_FIELDS.VINTAGE.NAME] || PUNCTUATION.EMPTY_VALUE}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.VOLUME.LABEL} (€M)</div>
        <div className="value">{formatNumber(entry[FUND_FIELDS.VOLUME.NAME])}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.DESCRIPTION.LABEL}</div>
        <div className="value">{entry[FUND_FIELDS.DESCRIPTION.NAME]}</div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.INDUSTRIES.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, FUND_FIELDS.INDUSTRIES).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, FUND_FIELDS.INDUSTRIES)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.GEOGRAPHIES.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, FUND_FIELDS.GEOGRAPHIES).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, FUND_FIELDS.GEOGRAPHIES)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.SITUATION.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, FUND_FIELDS.SITUATION).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, FUND_FIELDS.SITUATION)}
            visibleCount={88888}
          />
        </div>
      </div>
      <div className="row">
        <div className="bullet"></div>
        <div className="label">{FUND_FIELDS.EQUITY.LABEL}</div>
        <div className="value">
          {/* {utilsStore.getOptionName(entry, FUND_FIELDS.EQUITY).join(', ')} */}
          <ChipsList
            list={utilsStore.getOptionName(entry, FUND_FIELDS.EQUITY)}
            visibleCount={88888}
          />
        </div>
      </div>
    </div>
  );
});

export default FundGeneralInformation;
